import React, { FC } from 'react';
import { FiDownload } from 'react-icons/fi';
import cn from 'classnames';
import TooltipPoratal from 'components/UI/TooltipPoratal';
import { useTranslation } from 'react-i18next';
import css from './style.module.scss';

type DownloadButtonProps = {
  onClick: () => void;
  disabled: boolean;
  classname?: string;
};

const DownloadButton: FC<DownloadButtonProps> = ({
  onClick,
  disabled,
  classname,
}) => {
  const { t } = useTranslation();

  return (
    <div
      className={cn(css.download, classname, {
        disabled,
      })}
    >
      <TooltipPoratal
        hint={t('report.download')}
        hintWidth={150}
        isDisabled={disabled}
      >
        <FiDownload size={24} onClick={onClick} className={css.download__btn} />
      </TooltipPoratal>
    </div>
  );
};

export default DownloadButton;
